<template>
	<LayoutBreadcrumbs v-if="slug?.length" class="main-wrapper" />

	<StoryblokComponent v-if="story" :blok="story.content" />
</template>

<script setup lang="ts">
import { getStoryblokVersion } from "~/utils/storyblok/getStoryblokVersion";
import { fetchStoryblokContentByFolder } from "~/utils/storyblok/fetchStoryblokContentByFolder";

const { slug } = useRoute().params;
const { localeProperties, t } = useI18n();
const { setPageType } = usePageStore();
const { helloRetailApi } = useNorcePwa();
const config = useRuntimeConfig();
const {
	public: {
		categoryContentKey,
		norce: { isHelloRetailTracking }
	}
} = config;
const storyblokApi = useStoryblokApi();

if (slug?.includes(categoryContentKey)) {
	showError({
		statusCode: 404,
		statusMessage: t("errors.page_not_found.title"),
		message: t("errors.page_not_found.message")
	});
}

const path = slug ? slug.join("/") : "home";
const story = ref();
try {
	const { data } = await fetchStoryblokContentByFolder(
		storyblokApi,
		path,
		{
			version: getStoryblokVersion(),
			language: localeProperties.value.iso,
			resolve_links: "url"
		},
		{
			storyblokFolder: config.public.storyblokFolder,
			storyblokFallbackFolder: config.public.storyblokFallbackFolder
		}
	);
	story.value = data.story;
} catch {
	showError({
		statusCode: 404,
		statusMessage: t("errors.page_not_found.title"),
		message: t("errors.page_not_found.message")
	});
}

if (!story.value) {
	showError({
		statusCode: 404,
		statusMessage: t("errors.page_not_found.title"),
		message: t("errors.page_not_found.message")
	});
}

if (story.value) {
	if (!slug?.length) {
		setPageType("home");
	} else {
		setPageType("cms");
	}
}
if (story.value?.content.SEO) {
	useSeoMeta({
		title: story.value.content.SEO.title,
		ogTitle: story.value.content.SEO.og_title,
		description: story.value.content.SEO.description,
		ogDescription: story.value.content.SEO.og_description
	});
	if (import.meta.server) {
		const appStore = useAppStore();
		defineOgImageComponent("OgCms", {
			image: story.value.content.SEO.og_image,
			logo: appStore.siteLogo?.filename || "",
			title: story.value.content.SEO.og_title || "",
			description: story.value.content.SEO.description || "",
			width: 1200,
			height: 630
		});
	}
}

useSchemaOrg([
	defineWebPage({
		"@type": "WebPage",
		name: story.value?.content?.title || "",
		description: story.value?.content?.SEO?.description || "",
		image: story.value?.content?.SEO?.og_image || undefined
	})
]);

onMounted(() => {
	if (!isHelloRetailTracking) return;

	helloRetailApi.track({
		serviceType: "pageview",
		trackingData: {
			location: window.location.href,
			referrer: window.location.origin,
			url: window.location.href
		}
	});
});
</script>
